import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Tooltip } from '@src/components/Tooltip';
import { Appearance, Button } from '@src/components/Button';
import { isActive as isOpeningActive } from '@src/util/opening';
import FrChatSvg from '@src/svgs/fr-chat-small.svg';
import { Connect } from '../Connect';
import { ConnectHideActionsProps } from './props';
import './styles.scss';

export const ConnectHideActions: FC<ConnectHideActionsProps> = ({
  areActionsEnabled,
  isHideActionVisible,
  activeOpeningId,
  openingState,
  inactiveMessage,
  onDiscard,
  onConfirmClick,
}) => {
  const overlayStyle = {
    maxWidth: '25rem',
    textAlign: 'center',
  };

  return (
    <div className="connect-hide-actions">
      {onDiscard && isHideActionVisible ? (
        !areActionsEnabled || (activeOpeningId && !isOpeningActive(openingState)) ? (
          <Tooltip overlay={inactiveMessage} overlayStyle={overlayStyle} placement="top">
            <div className="connect-hide-actions__action-disabled">Hide</div>
          </Tooltip>
        ) : (
          <Button appearance={Appearance.PRIMARY} className="connect-hide-actions__discard" onClick={onDiscard}>
            Hide
          </Button>
        )
      ) : null}

      {onConfirmClick &&
        (!areActionsEnabled && activeOpeningId && !isOpeningActive(openingState) ? (
          <Tooltip overlay={inactiveMessage} overlayStyle={overlayStyle} placement="top">
            <div className="connect-hide-actions__action-disabled">
              <Svg
                className="connect-hide-actions__action-icon connect-hide-actions__action-icon--grey"
                src={FrChatSvg}
              />
              Contact me
            </div>
          </Tooltip>
        ) : !areActionsEnabled ? (
          <div className="connect-hide-actions__action-disabled">
            <Svg
              className="connect-hide-actions__action-icon connect-hide-actions__action-icon--grey"
              src={FrChatSvg}
            />
            Contact me
          </div>
        ) : (
          <Connect activeOpeningId={activeOpeningId} onConfirmTalent={onConfirmClick} />
        ))}
    </div>
  );
};
